// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.
import { metrics, type BaseMetric } from '@atlassian/browser-metrics';
import { PERFORMANCE_METRIC_PREFIX, PERFORMANCE_MARK } from '../constants.tsx';

export const isMetricRunning = (metric: BaseMetric) => metric?.state === 'started';

export const openMenuItemLoadTime = metrics.custom({
	key: `${PERFORMANCE_METRIC_PREFIX}.open.menu-item.load`,
	timings: [{ key: PERFORMANCE_MARK.BUNDLE_LOAD_START, endMark: PERFORMANCE_MARK.BUNDLE_LOAD_END }],
});

export const qsButtonAutoLoadTime = metrics.custom({
	key: `${PERFORMANCE_METRIC_PREFIX}.button.load`,
	timings: [{ key: PERFORMANCE_MARK.BUNDLE_LOAD_START, endMark: PERFORMANCE_MARK.BUNDLE_LOAD_END }],
});

export const qsChecklistAutoLoadTime = metrics.custom({
	key: `${PERFORMANCE_METRIC_PREFIX}.checklist.load`,
	timings: [{ key: PERFORMANCE_MARK.BUNDLE_LOAD_START, endMark: PERFORMANCE_MARK.BUNDLE_LOAD_END }],
});

export const qsChecklistMinimiseInteraction = metrics.interaction({
	key: `${PERFORMANCE_METRIC_PREFIX}.checklist.minimize`,
});

export const qsChecklistDismissInteraction = metrics.interaction({
	key: `${PERFORMANCE_METRIC_PREFIX}.checklist.dismiss`,
});

export const qsButtonOpenInteraction = metrics.interaction({
	key: `${PERFORMANCE_METRIC_PREFIX}.button.open`,
});

export const qsButtonDismissInteraction = metrics.interaction({
	key: `${PERFORMANCE_METRIC_PREFIX}.button.dismiss`,
});
